// duration minutes between times in time options
export const TIME_DURATION_OPTIONS = {
  default: 30,
  'm-gebauer.myshopify.com': 15,
  'bc-dev-v2-quinn03.myshopify.com': 15
};
